var React = require('react');

function GreyArrowIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#bdbdbd"},React.createElement("path",{"d":"M130.904 493.395c.709 0 1.407.18 2.027.525l23.913 13.258c2.019 1.12 2.748 3.664 1.629 5.683-.38.685-.944 1.25-1.63 1.63l-23.912 13.258c-2.02 1.12-4.564.39-5.683-1.629-.344-.62-.525-1.318-.525-2.027v-2.536h-6.543c-2.308 0-4.18-1.87-4.18-4.18v-13.45c0-2.308 1.872-4.18 4.18-4.18h6.543v-2.171c0-2.31 1.872-4.18 4.18-4.18z","transform":"translate(-118 -493) matrix(-1 0 0 1 277.121 0)"}))));
}

GreyArrowIcon.defaultProps = {"width":"44","height":"36","viewBox":"0 0 44 36"};

module.exports = GreyArrowIcon;

GreyArrowIcon.default = GreyArrowIcon;
